<div class="remote-video">
  <ng-container [ngTemplateOutlet]="displayTemplate"></ng-container>
  <ng-template #localvideo>
    <app-localvideo></app-localvideo>
  </ng-template>
  <ng-template #remotevideo>
    <app-remotevideo></app-remotevideo>
  </ng-template>
</div>

<div class="call-wrapper video_call_wrapper text-center"
  *ngIf="
    apiservice.remote_video
      ? !apiservice.remote_view_data.videoStatus
      : !apiservice.session_details.video_status
  "
>
  <div class="pause_video">
    <div class="my-2 pause_icon">
      <em class="bi bi-camera-video-off-fill btn-icon"></em>
    </div>
    <h3 class="my-2 text-white">Video Paused</h3>
  </div>
</div>
